export const setCompareResult = (state, action) => {
  return { ...state, compareResult: action.payload }
}
